import { createRouter, createWebHashHistory } from 'vue-router';
import { GetRouteAccess } from '../services/Users/GetRouteAccess';
import routes from './routes';
import { useRouteAccessStore } from '../stores/routeAccess';
import { useGlobalLoaderStore } from '../stores/globalLoader';
import {
  hasNoAccess,
  redirectNoAccess,
  hasfeatureFlagId,
  hasSpaMigrationFlagId,
  checkFlags,
  redirectToLegacy,
} from './router-business';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, _, next) => {
  if (to.name === 'route-to-v1') {
    redirectToLegacy(to.query.redirectTo);

    return;
  }

  if ('auth' in to.meta && to.meta.auth) {
    const routeAccessStore = useRouteAccessStore();
    const loader = useGlobalLoaderStore();
    const moduleId = to.meta.moduleId;

    loader.showLoader();

    GetRouteAccess(moduleId)
      .then((response) => {
        const toPath = encodeURIComponent(to.path);
        const queryString = `?path=${toPath}`;
        const defaultRedirectUrl = `${response.redirectUrl + queryString}`;

        if (
          !response.isAuthenticated ||
          !response.isAllowedToAccess ||
          hasNoAccess(to.name, response.accessLevelStatus)
        ) {
          redirectNoAccess(response, queryString);

          return;
        }

        loader.hideLoader();

        routeAccessStore.$patch({ routeAccess: { ...response } });

        if (hasfeatureFlagId(to.meta) || hasSpaMigrationFlagId(to.meta)) {
          loader.showLoader();

          checkFlags(to.meta, defaultRedirectUrl);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  next();
});

const DEFAULT_TITLE = 'HR Hub';

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});

export default router;
